__turbopack_context__.v({
  "blue": "Carousel-module-scss-module__m1eJ4G__blue",
  "button": "Carousel-module-scss-module__m1eJ4G__button",
  "container": "Carousel-module-scss-module__m1eJ4G__container",
  "cream": "Carousel-module-scss-module__m1eJ4G__cream",
  "disableNavigation": "Carousel-module-scss-module__m1eJ4G__disableNavigation",
  "fade-in": "Carousel-module-scss-module__m1eJ4G__fade-in",
  "hideScrollBars": "Carousel-module-scss-module__m1eJ4G__hideScrollBars",
  "icon": "Carousel-module-scss-module__m1eJ4G__icon",
  "inlineIntro": "Carousel-module-scss-module__m1eJ4G__inlineIntro",
  "isBeginning": "Carousel-module-scss-module__m1eJ4G__isBeginning",
  "isInView": "Carousel-module-scss-module__m1eJ4G__isInView",
  "navigation": "Carousel-module-scss-module__m1eJ4G__navigation",
  "next": "Carousel-module-scss-module__m1eJ4G__next",
  "orange": "Carousel-module-scss-module__m1eJ4G__orange",
  "prev": "Carousel-module-scss-module__m1eJ4G__prev",
  "root": "Carousel-module-scss-module__m1eJ4G__root",
  "slide": "Carousel-module-scss-module__m1eJ4G__slide",
  "track": "Carousel-module-scss-module__m1eJ4G__track",
});
